import { GET_PROFILE_SUCCESS, UPDATE_PROFILE_SUCCESS } from './constants';
import { API_ZAPIER_DISCONNECT_SUCCESS } from '../apiSettings/constants';
import { GET_TENANTS_LIST_SUCCESS } from '../../data/admin/constants';

/**
 *
 * @param state
 * @param action
 * @returns {({}&{tenants: *})|*}
 */

let stateData = {};
const profileReducer = ( state = stateData, action ) => {
    switch ( action.type ) {
        case GET_PROFILE_SUCCESS:
            return { ...state, ...action.profile };
        case UPDATE_PROFILE_SUCCESS:
            return { ...state, ...action.profile };
        case GET_TENANTS_LIST_SUCCESS: {
            return { ...state, tenants: action.tenants };
        }
        case API_ZAPIER_DISCONNECT_SUCCESS :{
            return { ...state,  api_settings:{...state.api_settings,zapier:{...state.api_settings.zapier, zapier_connect: action.result.zapier_connect }} };
        }
        default:
            return state;
    }
};

export default profileReducer;